import './email-verification.css';

import './img/open-mail.svg';
import './img/verification-complete.svg';
